import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';

const StockInformationPage = ({ hookData }) => {
    const {
        toast,
        activeTab,
        setActiveTab,
        filters,
        selectedPartCode,
        stockList,
        totalRecords,
        stockHistoryList,
        isLoadingStock,
        isLoadingHistory,
        handleHistoryClick,
        formatDate,
        statusBodyTemplate,
        transactionTypeTemplate,
        first,
        onPageChange,
        onSort,
        sortField,
        sortOrder,
        th
    } = hookData;

    const historyButtonTemplate = (rowData) => (
        <Button icon="pi pi-history" className="p-button-rounded p-button-text p-button-sm" onClick={() => handleHistoryClick(rowData.partCode)} tooltip={th('dealerPartsCatalog.stockInformation.table.viewHistory')} />
    );

    return (
        <div>
            <Toast ref={toast} />
            <div className="flex justify-content-between align-items-center mb-4">
                <h2 className="m-0">{th('dealerPartsCatalog.stockInformation.pageTitle')}</h2>
            </div>

            <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                <TabPanel header={th('dealerPartsCatalog.stockInformation.tabs.stockInfo')}>
                    <DataTable
                        value={stockList}
                        loading={isLoadingStock}
                        emptyMessage={th('dealerPartsCatalog.stockInformation.messages.noRecords')}
                        paginator
                        rows={filters.pageSize}
                        rowsPerPageOptions={[10, 20, 50]}
                        totalRecords={totalRecords}
                        lazy
                        first={first}
                        onPage={onPageChange}
                        onSort={onSort}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        stripedRows
                        showGridlines
                    >
                        <Column header={th('dealerPartsCatalog.stockInformation.table.history')} body={historyButtonTemplate} />
                        <Column field="partCode" header={th('dealerPartsCatalog.stockInformation.table.partCode')} sortable />
                        <Column field="partDesc" header={th('dealerPartsCatalog.stockInformation.table.partDescription')} sortable />
                        <Column field="uom" header={th('dealerPartsCatalog.stockInformation.table.uom')} sortable />
                        <Column field="quantity" header={th('dealerPartsCatalog.stockInformation.table.quantity')} body={(rowData) => rowData.quantity?.toLocaleString(th('common.locale')) || '0'} sortable />
                        <Column field="branchInfo" header={th('dealerPartsCatalog.stockInformation.table.branchInfo')} sortable />
                        <Column field="warehouseName" header={th('dealerPartsCatalog.stockInformation.table.warehouse')} sortable />
                        <Column field="isActive" header={th('dealerPartsCatalog.stockInformation.table.status')} body={statusBodyTemplate} sortable />
                        <Column field="createdDate" header={th('dealerPartsCatalog.stockInformation.table.createdDate')} body={(rowData) => formatDate(rowData.createdDate)} sortable />
                    </DataTable>
                </TabPanel>
                <TabPanel header={th('dealerPartsCatalog.stockInformation.tabs.stockHistory')}>
                    {selectedPartCode && (
                        <div className="mb-3">
                            <p>{th('dealerPartsCatalog.stockInformation.messages.viewingHistoryFor').replace('{partCode}', selectedPartCode)}</p>
                        </div>
                    )}
                    <DataTable
                        value={stockHistoryList}
                        loading={isLoadingHistory}
                        emptyMessage={selectedPartCode ? th('dealerPartsCatalog.stockInformation.messages.noHistory') : th('dealerPartsCatalog.stockInformation.messages.selectPartForHistory')}
                        paginator
                        rows={10}
                        stripedRows
                        showGridlines
                    >
                        <Column field="partCode" header={th('dealerPartsCatalog.stockInformation.table.partCode')} />
                        <Column field="source" header={th('dealerPartsCatalog.stockInformation.table.source')} />
                        <Column field="uom" header={th('dealerPartsCatalog.stockInformation.table.uom')} />
                        <Column field="quantity" header={th('dealerPartsCatalog.stockInformation.table.quantity')} body={(rowData) => rowData.quantity?.toLocaleString(th('common.locale')) || '0'} />
                        <Column field="warrClaimsNo" header={th('dealerPartsCatalog.stockInformation.table.warrantyClaimNo')} />
                        <Column field="orderNumber" header={th('dealerPartsCatalog.stockInformation.table.orderNumber')} />
                        <Column field="invoiceSerialNum" header={th('dealerPartsCatalog.stockInformation.table.invoiceNumber')} />
                        <Column field="transactionType" header={th('dealerPartsCatalog.stockInformation.table.transactionType')} body={transactionTypeTemplate} />
                        <Column field="description" header={th('dealerPartsCatalog.stockInformation.table.description')} />
                        <Column field="createdDate" header={th('dealerPartsCatalog.stockInformation.table.date')} body={(rowData) => formatDate(rowData.createdDate)} />
                    </DataTable>
                </TabPanel>
            </TabView>
        </div>
    );
};

export default StockInformationPage;
